// extracted by mini-css-extract-plugin
module.exports = {"returnsModal":"styles_returnsModal__0wbRR","returnsModal__content":"styles_returnsModal__content__UY86B","returnsModal__message":"styles_returnsModal__message___cFyU"};